/** Jobs a nurse can carry in a week; capacity = nurses × this. */
export const TARGET_JOBS_PER_NURSE_PER_WEEK = 15;

/** Within this share of capacity counts as "at capacity". */
const AT_CAPACITY_MARGIN = 0.1;

export type Verdict = "over" | "no-nurses" | "at-capacity" | "room";

/** Spare jobs per week the nurses could still take; negative when over. */
export function headroom(jobsPerWeek: number, nurses: number): number {
  return nurses * TARGET_JOBS_PER_NURSE_PER_WEEK - jobsPerWeek;
}

export function verdictFor(jobsPerWeek: number, nurses: number): Verdict {
  if (nurses === 0) return "no-nurses";
  const spare = headroom(jobsPerWeek, nurses);
  if (spare < 0) return "over";
  const capacity = nurses * TARGET_JOBS_PER_NURSE_PER_WEEK;
  if (spare < capacity * AT_CAPACITY_MARGIN) return "at-capacity";
  return "room";
}
